import { USERAGENT } from './consts'

export const addZero = num => {
  if (num >= 0 && num <= 9) {
    return '0' + num
  } else {
    return num
  }
}

export const isSafari = () => {
  if (USERAGENT.indexOf('safari') !== -1) {
    if (USERAGENT.indexOf('chrome') > -1) return false
    return true
  }
}

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }

  return 'unknown'
}


export const getSplittedCardExpiryDate = cardExpiryDate => {
  const splitted = cardExpiryDate.split('/')
  return {
    month: splitted[0].trim(),
    year: splitted[1].trim(),
  }
}